import React from 'react';

function SubscriptionIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        id="Round"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM4 10H20V5C20 4.45 19.55 4 19 4H5C4.45 4 4 4.45 4 5V10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SubscriptionIcon;
